import { render, staticRenderFns } from "./NtyInspJrnls.vue?vue&type=template&id=0f486154&"
import script from "./NtyInspJrnls.vue?vue&type=script&lang=js&"
export * from "./NtyInspJrnls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports